import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 10 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 19\" id=\"icon-arrow-right\"><path d=\"M9.734 8.432L1.567.268a.92.92 0 0 0-1.299 0 .915.915 0 0 0 0 1.295l7.52 7.517L.27 16.597a.916.916 0 0 0 0 1.296.92.92 0 0 0 1.299 0L9.735 9.73a.925.925 0 0 0 0-1.297z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol